interface BannerApiData {
    displayCount?: number;
    dataIdentifier: string;
    includeCustomHTML?: boolean;
}

export const FetchBannerApiData = async ({
    displayCount = 1,
    dataIdentifier,
    includeCustomHTML = false,
}: BannerApiData) => {
    const body = {
        displayCount,
        dataIdentifier,
        includeCustomHTML,
    };

    const url = '/api/v1/banners/filter';

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });

    const data = await response.json();
    return data;
};
